module.exports = __webpack_public_path__ + "static/media/wave-minor-warning.048f7289.png";